import React from 'react';
import { Tag } from 'govuk-react';

import { capitalizeFirst } from '../hooks/useStringFunc';

// being debated with CPRD, the coloured status tags may come back into play so are left here temporarily

type GetTagProps = {
  roles: any;
}

export const GetTag = ({ roles }: GetTagProps) => {
  const listOfRoles = roles;

  const getRoleTag = (role: string) => {
    switch (role) {
      case "treadmin":
        return <Tag key="1" backgroundColor="#912b88" color="#fff">admin</Tag>;
      case "airlock manager":
        return <Tag key="2" backgroundColor="#4c2c92" color="#fff">{role}</Tag>
      case "treuser":
        return <Tag key="3" backgroundColor="#6f72af" color="#fff">researcher</Tag>
      case "workspace owner":
        return <Tag key="4" backgroundColor="#f7d7e6" color="#80224d">{role}</Tag>
      default:
        return <Tag key="5" backgroundColor="#dbd5e9" color="#383f43">"Request name"</Tag>;
    }
  };

  return listOfRoles.map((role: string) => getRoleTag(role.toLowerCase()));
}

type GetStatusTagProps = {
  status: string;
}

export const GetStatusTag = ({ status }: GetStatusTagProps) => {
  const formattedStatus = status.replace(/_/g, ' ');

  const getTag = (status: string) => {
    switch (status) {
      case "DRAFT":
        return <Tag tint="BLUE">{status}</Tag>
      case "IN REVIEW":
        return <Tag tint="YELLOW">{status}</Tag>
      case "APPROVED":
        return <Tag tint="TURQUOISE">{status}</Tag>
      case "REJECTED":
        return <Tag tint="RED">{status}</Tag>
      case "FAILED":
        return <Tag tint="RED">{status}</Tag>
      default:
        return <Tag tint="BLUE">{status}</Tag>
    }
  }

  return getTag(formattedStatus.toUpperCase());
}

export const GetStatus = ({ status }: GetStatusTagProps) => {
  const formattedStatus = status.replace(/_/g, ' ');

  const getTag = (status: string) => {
    switch (status) {
      case "draft":
        return <p>{capitalizeFirst(status)}</p>
      case "in review":
        return <p>{capitalizeFirst(status)}</p>
      case "approved":
        return <p>{capitalizeFirst(status)}</p>
      case "rejected":
        return <p>{capitalizeFirst(status)}</p>
      case "failed":
        return <p>{capitalizeFirst(status)}</p>
      default:
        return <p>{capitalizeFirst(status)}</p>
    }
  }

  return getTag(formattedStatus.toLowerCase());
}

type GetServiceTypeProps = {
  templateName: string;
}

export const GetServiceType = ({ templateName }: GetServiceTypeProps) => {
  const getType = (name: string) => {
    switch (name) {
      case "tre-service-guacamole":
        return "Guacamole"
      case "tre-workspace-service-ohdsi":
        return "Atlas"
      case "tre-workspace-service-gitea":
        return "Gitea"
      default:
        return ""
    } 
  }

  return getType(templateName);
}
